import {IPageSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {StubBoxView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/StubBoxView';
import {BoxId} from '@mintdata/mint-kit/api/models/Identifiers';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {DraggableCore, DraggableData} from 'react-draggable';

const styles = require('./SurfaceStubPage.less');
const cx = classnames.bind(styles);

export interface ISurfaceStubPageProps
{
    page:IPageSnapshot;
    isActive:boolean;
}

@observer
export class SurfaceStubPage extends React.Component<ISurfaceStubPageProps, any>
{
    public render():JSX.Element
    {
        const {page, isActive} = this.props;

        const boxesElements:Array<JSX.Element> = page.artboard.boxes.map((boxId:BoxId) => (
            <StubBoxView key={boxId} box={page.artboard.allBoxes[boxId]} />
        ));

        return (
            <div className={cx('page', {isActive})}>
                {boxesElements}
            </div>
        );
    }
}
